import { Poppins, Quicksand } from 'next/font/google';
import React from 'react'
import Breadcrumbs from './breadcrumb';
const extrapopins = Poppins({weight:"600", subsets:['latin']});
export default function BreadcumbSection({pageTitle}) {
  return (
    <>
    <section className='breadcrumb-bg'>
        <div className='container df fac fjc'>
         <div className='df fjc fdc'>   
        <h4 className={`fs-33 mfs-19 cw mtac ${extrapopins.className}`}>{pageTitle}</h4>
        <Breadcrumbs/>
        </div>
        </div>
    </section>
    <style jsx>
        {`
        .breadcrumb-bg{
        background-image: url('/breadcrumb-bg.webp');
        width:100%;
        height: 211px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
       
        background-size: 100% 100%;
        }
        @media only screen and (max-width: 1023px){
                .breadcrumb-bg{
        background-image: url('/breadcrumb-bg.webp');
        width:100%;
        height: auto;
        padding: 20px 0px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        }
        }
        
        `}
    </style>
    </>
  )
}
